import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { CpfValidator } from "./cpf-validator";

const cnpjLengthWithoutDV = 12;
const regexCnpj = /^([A-Z\d]){12}(\d){2}$/;
const regexNotAllowedCharacters = /[^A-Z\d./-]/i;
const baseCharCode = '0'.charCodeAt(0);
const dvWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const zeroCnpj = '00000000000000';

export const CpfCnpjAlphanumericValidator: ValidatorFn =
  (control: AbstractControl): ValidationErrors | null => {

    const controlValue = control.value || '';

    if (!controlValue) {
      return {};
    }

    if (controlValue.trim().length === 11) {
      return CpfValidator(control);
    } else {
      return CnpjAlphanumericValidator(control);
    }
};

export const CnpjAlphanumericValidator = (control: AbstractControl): ValidationErrors | null => {
  const cnpjValue = (control.value || '').trim().toUpperCase();

  if (cnpjValue == null || cnpjValue === '') return null;

  return isValidCNPJ(cnpjValue) ? null : { invalidCnpj: { value: control.value } };
};

function isValidCNPJ(cnpj: string): boolean {
  if (!regexNotAllowedCharacters.test(cnpj)) {
    if (regexCnpj.test(cnpj) && cnpj !== zeroCnpj) {
      const providedDV = cnpj.substring(cnpjLengthWithoutDV);
      const calculatedDV = calculateDV(cnpj.substring(0, cnpjLengthWithoutDV));
      return providedDV === calculatedDV;
    }
  }
  return false;
}

function calculateDV(cnpj: string): string {
  let sumDV1 = 0;
  let sumDV2 = 0;

  for (let i = 0; i < cnpjLengthWithoutDV; i++) {
    const digitValue = cnpj.charCodeAt(i) - baseCharCode;
    sumDV1 += digitValue * dvWeights[i + 1];
    sumDV2 += digitValue * dvWeights[i];
  }

  const dv1 = sumDV1 % 11 < 2 ? 0 : 11 - (sumDV1 % 11);
  sumDV2 += dv1 * dvWeights[cnpjLengthWithoutDV];
  const dv2 = sumDV2 % 11 < 2 ? 0 : 11 - (sumDV2 % 11);

  return `${dv1}${dv2}`;
}
